module.exports = __webpack_public_path__ + "static/media/clock.b13c6392.svg";